import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHistory } from "react-icons/fa";
import axios from 'axios';
import { useAuth } from '../../context/AuthContext'; // Importa el contexto de autenticación
import { toast } from 'react-toastify';

const CierreCaja = ({ caja, onCerrarCaja, resumen }) => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { token } = useAuth(); // Obtener el token desde el contexto
  // console.log(resumen);

  const cerrarCaja = async () => {
    try {
      await axios.put(`${import.meta.env.VITE_API_URL}/caja/cerrar/${caja.id}`, {}, {
        headers: { 'x-auth-token': token }
      });
      onCerrarCaja();
      setSuccess("Caja cerrada correctamente.");f

      toast.info(
        <div>
          <p className="font-semibold">💰 Caja cerrada</p>
          <p>Ingreso total: <strong>${caja?.saldo_final?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}</strong></p>
          <p>Efectivo: <strong>${caja?.saldo_efectivo_calculado?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}</strong></p>
          <p>Monto inicial: <strong>${caja?.saldo_inicial?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}</strong></p>
        </div>,
        {
          position: "top-right",
          autoClose: 5000, // 5 segundos
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 404) {
        localStorage.removeItem('cajaAbiertaId');
        onCerrarCaja();
        setError("La caja ya fue cerrada en otro dispositivo. Por favor, abra una nueva caja.");
      } else {
        console.error("Error al cerrar la caja:", error);
        console.log(error);

        setError("Error al cerrar la caja");
        toast.error('Error al cerrar la caja');
      }
    }
  };
console.log(resumen);

  const formaPagoLabels = {
    saldo_efectivo_calculado: "Efectivo",
    tarjeta: "Tarjeta",
    transferencia: "Transferencia",
    otros: "Otros",
    cuentaCorriente: "Cuenta Corriente",
  };

  return (
    <div className="bg-white p-6  mt-12 rounded-lg shadow-md">
      {/* Información principal */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-blue-50 rounded-xl p-4 shadow-sm border border-blue-200">
          <p className="text-gray-600 text-sm font-medium">Total de ventas</p>
          <p className="text-2xl font-bold text-blue-700 mt-1">
            ${resumen?.venta_total?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}
          </p>
        </div>
        <div className="bg-yellow-50 rounded-xl p-4 shadow-sm border border-yellow-200">
          <p className="text-gray-600 text-sm font-medium">Efectivo total en caja</p>
          <p className="text-2xl font-bold text-yellow-700 mt-1">
            ${resumen?.efectivo_total?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}
          </p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 rounded-t-xl">
          <h3 className="font-semibold text-gray-800">Detalle por Forma de Pago</h3>
        </div>
        <div className="p-4">
          <div className="space-y-2">
            {resumen?.detalle_por_pago &&
              Object.entries(resumen.detalle_por_pago).map(([forma, total]) => (
                <div
                  key={forma}
                  className="flex justify-between items-center py-3 px-3 transition-colors rounded-lg border-b border-gray-100 last:border-b-0"
                >
                  <span className="capitalize text-gray-700 font-medium">
                    {forma.charAt(0).toUpperCase() + forma.slice(1)}
                  </span>
                  <span className={`font-mono text-lg font-semibold ${total < 0 ? 'text-red-600' : 'text-green-700'}`}>
                    ${Number(total).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                  </span>
                </div>
              ))}
            {/* Saldo inicial por forma de pago (si existe) */}
            {caja?.saldo_inicial && (
              <div className="flex justify-between items-center py-3 px-3 transition-colors rounded-lg border-b border-gray-100">
                <span className="text-gray-700 font-medium">Saldo inicial</span>
                <span className="font-mono text-lg font-semibold">
                  ${caja.saldo_inicial.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                </span>
              </div>
            )}
            {/* Cobros CC en efectivo y Egresos en efectivo como líneas especiales */}
            <div className="flex justify-between items-center py-3 px-3 transition-colors rounded-lg border-b border-gray-100">
              <span className="text-gray-700 font-medium">Cobros CC en efectivo</span>
              <span className="font-mono text-lg font-semibold">
                ${resumen?.cobros_cc_en_efectivo?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}
              </span>
            </div>
            <div className="flex justify-between items-center py-3 px-3 transition-colors rounded-lg border-b border-gray-100">
              <span className="text-gray-700 font-medium">Egresos en efectivo</span>
              <span className="font-mono text-lg font-semibold">
                ${resumen?.egresos_en_efectivo?.toLocaleString('es-AR', { minimumFractionDigits: 2 }) ?? "0.00"}
              </span>
            </div>
          </div>
        </div>
      </div>


      <div className="flex flex-col gap-4 mt-8">
        <button
          onClick={cerrarCaja}
          className="flex-1 flex items-center justify-center gap-3 bg-red-600 rounded-xl py-4 px-6 text-white text-center shadow-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 transition-all text-lg font-semibold"
        >
          <span className="inline-flex items-center justify-center bg-white/20 rounded-full p-2">
            <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' /></svg>
          </span>
          Cerrar Caja
        </button>
        <Link
          to="/caja/historial"
          className="flex-1 flex items-center justify-center gap-3 bg-orange-500 rounded-xl py-4 px-6 text-white text-center shadow-lg hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 transition-all text-lg font-semibold"
        >
          <span className="inline-flex items-center justify-center bg-white/20 rounded-full p-2">
            <FaHistory className="text-2xl" />
          </span>
          Historial de Cajas
        </Link>
      </div>
    </div>
  );
};

export default CierreCaja;
